/**
 * Order status helpers.
 *
 * The `ORDER_STATUS_OPTIONS` table in `@entities/order/model/statuses`
 * is the source of truth for which statuses allow edits. Re-stating it
 * here as a small map keeps the lib pure data without forcing the
 * orderStatus consumer to walk the option array.
 *
 * Keep this in sync with the legacy table until that file is migrated.
 */

export const ORDER_STATUS = {
  sending: 'sending',
  pending: 'pending',
  processing: 'processing',
  shipped: 'shipped',
  onHold: 'onHold',
  delayed: 'delayed',
  canceled: 'canceled',
  compounding: 'compounding',
};

const EDITABLE_STATUSES = new Set([
  ORDER_STATUS.sending,
  ORDER_STATUS.pending,
  ORDER_STATUS.onHold,
  ORDER_STATUS.delayed,
]);

/**
 * Distribution sponsors can always edit; otherwise only the four
 * statuses above are editable. Mirrors the inline check in
 * `_legacy/components/Orders/Item/OrderEdit.jsx`.
 */
export const isOrderEditable = ({ status, isDistributionSponsor }) => {
  if (isDistributionSponsor) return true;
  if (!status) return false;
  return EDITABLE_STATUSES.has(status);
};
